const initialState = {
	open: false,
	quickAddedContract: false
}

const actionTypes = {
    OPEN_REPORT_VIEWER_DIALOG: "OPEN_REPORT_VIEWER_DIALOG",
	QUICK_ADDED_CONTRACT: "QUICK_ADDED_CONTRACT",
    CLOSE_REPORT_VIEWER_DIALOG: "CLOSE_REPORT_VIEWER_DIALOG"
}

export function openReportViewerDialog(){
    return {
        type: actionTypes.OPEN_REPORT_VIEWER_DIALOG,
    }
}

export function closeReportViewerDialog(){
    return {
        type: actionTypes.CLOSE_REPORT_VIEWER_DIALOG,
    }
}


export function quickAddedContract() {
	return {
		type: actionTypes.QUICK_ADDED_CONTRACT
	}
}


export default function (state = initialState, action) {
	switch (action.type) {
		case actionTypes.OPEN_REPORT_VIEWER_DIALOG:{
			return { 
				...state,
				open: true,
			}
		}
		case actionTypes.CLOSE_REPORT_VIEWER_DIALOG:{
				return { 
					...state,
					open: false,
				}
		}
		case actionTypes.QUICK_ADDED_CONTRACT: {
			return {
				...state,
				quickAddedContract: !state.quickAddedContract
			}
		}
	  default:
		return state
	}
}